import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

export default class ProjectGroupUserSettings extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    loadingFavorite = false

    async toggleFavorite() {
        this.loadingFavorite = true
        let data = {
            attributes: {
                isFavorite: !this['isFavorite'],
            },
        }
        await this.patch(data).catch((error) => (this.loadingFavorite = false))
        this.loadingFavorite = false
    }

    loadingIsHidden = false

    async toggleIsHidden() {
        this.loadingIsHidden = true
        let data = {
            attributes: {
                isHidden: !this['isHidden'],
            },
        }

        await this.patch(data).catch((error) => (this.loadingIsHidden = false))
        this.loadingIsHidden = false
    }

    async patch(data: any) {
        let body = this.formateBody(data.attributes, data.relationships)

        if (body) {
            let query = {
                include: [],
                body: {
                    data: {
                        id: this._id,
                        type: this._type,
                        ...body,
                    },
                },
            }

            let res = await Vue.prototype.$vbit.patch(
                'project',
                `projectGroupUserSettings/${this._id}`,
                query
            )

            this.initalize(res.data, res.included)

            return res
        }
    }
}
